import { useState } from "react";
import { Modal } from "react-bootstrap";
import { BaseURL } from "../../../constants/enum/baseURL.emum";

const Doc3GenPdf = (props: { sche: number; curri: number; type: string }) => {
  const { sche, curri, type } = props;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  return (
    <>
      <a
        className="btn  btn-primary"
        href={`${BaseURL.BASE_URL}/testdoc3/${sche}/${curri}`}
        target="_blank"
        rel="noreferrer"
      >
        รายงานการส่ง {type === "tqf" ? "มคอ." : "อชว."}3 ของหลักสูตร
      </a>
      {/* <button className="btn  btn-primary ms-1" onClick={handleShow}>
        รายงารการส่ง {type === "tqf" ? "มคอ." : "อชว."}3 ของหลักสูตร
      </button> */}
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            เอกสาร {type === "tqf" ? "มคอ." : "อชว."}3
          </Modal.Title>
        </Modal.Header>{" "}
        <Modal.Body>
          <iframe
            className="container-fluid"
            src={encodeURI(`${BaseURL.BASE_URL}/gendoc3/${sche}/${curri}`)}
            frameBorder="0"
            style={{ height: "100vh" }}
            title={`${type === "tqf" ? "มคอ." : "อชว."}3`}
          ></iframe>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Doc3GenPdf;
